export default {
    namespaced: true,

    state: {
        tab: { logUpdatesInstall: true },

        exportModal: false,

        exportParams: [],

        releaseInfo: {}
    },

    mutations: {
        setSelectedTab(state, tabId) {
            state.tab = {};

            if (tabId == 'logUpdatesInstall') state.tab.logUpdatesInstall = true;
            else if (tabId == 'logUpdatesDownload') state.tab.logUpdatesDownload = true;
            // else if (tabId == 'logUpdatesErrors') state.tab.logUpdatesErrors = true;
            else if (tabId == 'logUpdateContent') state.tab.logUpdateContent = true;
            else if (tabId == 'logUpdateHardware') state.tab.logUpdateHardware = true;
            // else if (tabId == 'logScheduleUpdateComponent') state.tab.updatesSchedule = true;
            else if (tabId == 'logUpdateLog') state.tab.logUpdateLog = true;
        },

        showExportModal(state) {
            state.exportModal = true;
        },

        hideExportModal(state) {
            state.exportModal = false;
        },

        setExportParams(state, params) {
            state.exportParams = params;
        },

        clearExportParams(state) {
            state.exportParams = [];
        },

        setReleaseInfo(state, release) {
            state.releaseInfo = release;
            localStorage.setItem('releaseInfo', JSON.stringify(state.releaseInfo.tbody));
        }
    }
};